module.exports = __webpack_public_path__ + "d8161168a94a35bfc4d250d39fa65204.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Light.eot
 ** module id = 357
 ** module chunks = 9
 **/